const routes = [
  {
    // 邮储银行集合页面
    path: '/postalBankHome',
    name: 'postalBankHome',
    component: () => import('@/views/postalBank/home.vue'),
    meta: {
      requiresAuth: false,
      title: '邮储银行集合页面'
    }
  },
  {
    // 云南邮储白名单H5项目-首页
    path: '/yunnanPostalWhiteList',
    name: 'yunnanPostalWhiteList',
    component: () => import('@/views/postalBank/yunnanPostalWhiteList/index.vue'),
    meta: {
      requiresAuth: false,
      title: '云南邮储白名单活动'
    }
  },
  {
    // 莆田信用卡用户国庆抽奖-首页
    path: '/PutianPostalNationalDayLottery',
    name: 'PutianPostalNationalDayLottery',
    component: () => import('@/views/postalBank/putianPostalNationalDayLottery/index.vue'),
    meta: {
      requiresAuth: true,
      title: '莆田信用卡用户国庆抽奖'
    }
  },
  {
    // 莆田邮储话费立减金-首页
    path: '/putianPhoneBillsReduction',
    name: 'putianPhoneBillsReduction',
    component: () => import('@/views/postalBank/putianPhoneBillsReduction/index.vue'),
    meta: {
      requiresAuth: true,
      title: '莆田邮储话费立减金'
    }
  },
]

export default routes
